import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../../../components/Navbar";
import Footer from "../../../components/Footer";
import ScreenNav from "../../components/SelectDevice/ScreenNav";
import Comment from "../../components/SelectDevice/Comments";
import { IoIosArrowDown } from "react-icons/io";
import MobileNav from "../../components/EstimatedPrice/MobileNav";
import { useNavigate } from "react-router-dom";
import { MdKeyboardArrowLeft } from "react-icons/md";
import { toast, ToastContainer } from "react-toastify";

function SelectDevice() {
  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState("");
  const [selectedBrandName, setSelectedBrandName] = useState("");
  const [selectedModel, setSelectedModel] = useState("");
  const [selectedModelName, setSelectedModelName] = useState("");
  const [deviceValue, setDeviceValue] = useState("");
  const [purchaseMonth, setPurchaseMonth] = useState("");
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBrands = async () => {
      const carecategorySkuCode = sessionStorage.getItem("carecategorySkuCode");
      if (!carecategorySkuCode) return;

      const options = {
        method: "GET",
        url: `${process.env.REACT_APP_BACKEND_URL}:8070/master-service/brands/find-by-category-for-careplan`,
        params: { categorySku: carecategorySkuCode },
        headers: { accept: "*/*" },
      };

      try {
        const { data } = await axios.request(options);
        setBrands(data);
      } catch (error) {
        console.error(error);
        toast.error("Failed to fetch brands.");
      }
    };

    fetchBrands();
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleBrandChange = async (e) => {
    const brandSkuCode = e.target.value;
    const brandName = e.target.options[e.target.selectedIndex].text;
    sessionStorage.setItem("carebrandSkuCode", brandSkuCode);
    setSelectedBrand(brandSkuCode);
    setSelectedBrandName(brandName);

    const carecategorySkuCode = sessionStorage.getItem("carecategorySkuCode");
    if (!carecategorySkuCode || !brandSkuCode) return;

    const options = {
      method: "GET",
      url: `${process.env.REACT_APP_BACKEND_URL}:8070/master-service/model/find-by-category-and-brand-for-careplan`,
      params: { categorySku: carecategorySkuCode, brandSku: brandSkuCode },
      headers: { accept: "*/*" },
    };

    try {
      const { data } = await axios.request(options);
      setModels(data);
    } catch (error) {
      console.error(error);
    }
  };

  const handleModelChange = (e) => {
    const modelSkuCode = e.target.value;
    const modelName = e.target.options[e.target.selectedIndex].text;
    sessionStorage.setItem("caremodelSkuCode", modelSkuCode);
    setSelectedModel(modelSkuCode);
    setSelectedModelName(modelName);
  };

  const handleDeviceValueChange = (e) => {
    const value = e.target.value;
    sessionStorage.setItem("caredeviceValue", value);
    setDeviceValue(value);
  };

  const handlePurchaseMonthChange = (e) => {
    const month = e.target.value;
    setPurchaseMonth(month);
  };

  const handleContinue = () => {
    const authToken = localStorage.getItem("authToken");
    const data = {
      brand: selectedBrandName,
      model: selectedModelName,
      value: deviceValue,
      purchaseDuration: purchaseMonth,
    };
    // console.log(selectedBrandName, selectedModelName, deviceValue, purchaseMonth)
    if (authToken) {
      navigate("/care-flow/estimated-price", { state: data });
    } else {
      navigate("/care-flow/sign-up", { state: data });
    }
  };
  const handleGoBack = () => {
    navigate("/care-flow");
  };

  return (
    <div>
      <ToastContainer />
      <div className="bg-[#F9FAFB] sm:mx-[60px] pt-[16px] px-[30px] pb-[90px] min-h-[680px] rounded-b-[40px]">
        <div>
          <Navbar />
        </div>
        <div className="lg:hidden flex justify-center items-center my-8">
          <MobileNav />
        </div>
        <button
          onClick={handleGoBack}
          className="hidden ml-[48px] my-[60px] px-4 mb-4 py-[6px] sm:flex items-center justify-center gap-2 bg-white border border-gray-300 rounded-md shadow-sm"
        >
          <span className="">
            <MdKeyboardArrowLeft />
          </span>
          <span className="font-bold whitespace-nowrap font-plus-jakarta-sans text-[14px] leading-[20px]">
            Go Back
          </span>
        </button>
        <div className="grid sm:grid-cols-6 grid-cols-1 justify-center sm:mt-[60px] xl:mt-[40px]">
          <div className="col-span-4 sm:ml-[48px] ">
            <div className="text-left">
              <h1 className="sm:text-4xl text-3xl font-plus-jakarta-sans sm:text-[36px] text-[#101828] sm:text-center text-left lg:text-left font-bold leading-[44px]  max-w-[300px] lg:max-w-[500px]">
                Select your device
              </h1>
              <p className="text-gray-500 font-plus-jakarta-sans mt-[8px]">
                Select your device that needs to be warranted.
              </p>
            </div>
            <div className="sm:mt-[40px] mt-[24px] sm:mr-[32px] flex flex-col gap-4">
              <div className="relative w-full">
                <select
                  className=" block overflow-hidden appearance-none text-[16px] w-full bg-white border border-gray-300 text-[#667085] py-3 px-4 pr-8 rounded-md leading-tight focus:outline-none"
                  onChange={handleBrandChange}
                  value={selectedBrand}
                >
                  <option value="" disabled>Brand</option>
                  {brands.map((brand) => (
                    <option key={brand.skuCode} value={brand.skuCode}>
                      {brand.name}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <IoIosArrowDown className="text-[#667085] h-5 w-5" />
                </div>
              </div>
              <div className="relative">
                <select
                  className="block appearance-none text-[16px] w-full bg-white border border-gray-300 text-[#667085] py-3 px-4 pr-8 rounded-md leading-tight focus:outline-none"
                  onChange={handleModelChange}
                  value={selectedModel}
                >
                  <option value="" disabled>Model</option>
                  {models.map((model) => (
                    <option key={model.skuCode} value={model.skuCode}>
                      {model.name}
                    </option>
                  ))}
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <IoIosArrowDown className="text-[#667085] h-5 w-5" />
                </div>
              </div>
              <div>
                <input
                  type="text"
                  placeholder="Device Value"
                  className="block w-full bg-white border border-gray-300 placeholder:text-[#667085] py-3 px-4 pr-8 rounded-md leading-tight focus:outline-none"
                  onChange={handleDeviceValueChange}
                  value={deviceValue}
                />
              </div>
              <div className="relative">
                <select
                  className="block appearance-none text-[16px] w-full bg-white border border-gray-300 text-[#667085] py-3 px-4 pr-8 rounded-md leading-tight focus:outline-none"
                  onChange={handlePurchaseMonthChange}
                  value={purchaseMonth}
                >
                  <option value="" disabled hidden>
                    Purchase Duration
                  </option>
                  <option value="<1 year">{'<1 year'}</option>
                  <option value="<2 years">{'<2 years'}</option>
                  <option value="2 years">{'2 years +'}</option>
                </select>
                <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                  <IoIosArrowDown className="text-[#667085] h-5 w-5" />
                </div>
              </div>
            </div>
            <div className="mt-8">
              <button
                type="submit"
                className="bg-yellow-500 text-black font-bold py-[10px] px-[18px] rounded-md"
                onClick={handleContinue}
              >
                Continue
              </button>
            </div>
          </div>
          <div className="col-span-2 sm:border-l sm:px-[42px]">
            <div className="lg:block hidden self-center mb-[-20px]">
              <ScreenNav />
            </div>
            <Comment />
          </div>
        </div>
      </div>
      <div className="sm:mx-[50px]">
        <Footer />
      </div>
    </div>
  );
}

export default SelectDevice;
